//MUI IMPORTS
import {
  Container,
  Box,
  Grid,
  Typography,
  TextField,
} from "@mui/material";

function Impuestos(props) {
  /* --------------------------- HANDLERS ------------------------------  */
  const handleOnChange = (e) => {
    props.setDataCliente({
      ...props.dataCliente,
      [e.target.name]: e.target.value,
    });
  };

  /* --------------------------- RENDER ------------------------------  */
  return (
    <div>
      <Container maxWidth="xl" sx={{ py: 1 }}>
        <Box boxShadow={3} px={2} py={1} backgroundColor="#ebebeb">
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" sx={{ fontSize: 16 }} color="primary">
              Impuestos Nacionales (Percepción de Iva)
            </Typography>
          </Grid>

          <Grid
            container
            spacing={1}
            direction="row"
            alignItems="flex-start"
            justifyContent="flex-start"
            py={1}
          >
            <Grid item xs={6}>
              <TextField
                error={props.dataCliente.porc_exc_perc_iva > 100}
                helperText={
                  props.dataCliente.porc_exc_perc_iva > 100
                    ? "El % no puede ser mayor a 100"
                    : ""
                }
                style={{ backgroundColor: "#fff" }}
                size="small"
                fullWidth
                focused
                label="% Excención"
                value={props.dataCliente.porc_exc_perc_iva}
                name="porc_exc_perc_iva"
                onChange={handleOnChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                style={{ backgroundColor: "#fff" }}
                type="date"
                size="small"
                fullWidth
                focused
                label="Vto Excención"
                InputLabelProps={{ shrink: true }}
                value={props.dataCliente.vto_exc_perc_iva}
                name="vto_exc_perc_iva"
                onChange={handleOnChange}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
}

export default Impuestos;
